module.exports = __webpack_public_path__ + "static/media/alligator_strap_black.eab1b078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alligator_strap_black.png
// module id = 103
// module chunks = 0